import { COLORS, COMMON_STYLES, TEXT_STYLES, TYPOGRAPHY, VARIANTS_STYLES } from '@dehaat/dds'
import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  container: {
    padding: 12,
    paddingBottom: 88,
    backgroundColor: COLORS.white,
  },
  formSection: {
    paddingTop: 4,
  },
  sectionTitle: {
    ...TEXT_STYLES.textNeutral90,
    ...TYPOGRAPHY.TEXT1,
    ...VARIANTS_STYLES.SEMI_EMPHASIZED,
    marginBottom: 12,
  },
  section: {
    ...TEXT_STYLES.textNeutral90,
    ...TYPOGRAPHY.TEXT1,
    ...VARIANTS_STYLES.SEMI_EMPHASIZED,
    marginBottom: 8,
    marginTop: 16,
  },
  fieldNote: {
    ...TYPOGRAPHY.CAPTION1,
    ...TEXT_STYLES.textNeutral70,
    ...VARIANTS_STYLES.MEDIUM,
    marginTop: 4,
    marginBottom: 4,
    marginLeft: 4,
    lineHeight: 18,
  },
  fieldWrap: {
    marginBottom: 12,
  },
  footer: {
    position: 'absolute',
    left: 12,
    right: 12,
    bottom: 12,
  },
  screenBg: {
    backgroundColor: COLORS.white,
  },
  sectionDividerBand: {
    marginHorizontal: -12,
    height: 12,
    backgroundColor: COLORS.neutral10,
    marginTop: 8,
    marginBottom: 16,
  },
  phoneBigInput: {
    height: 64,
    borderRadius: 8,
    borderColor: '#CED8E0',
    marginBottom: 2,
  },
  phoneBigInputLeft: {
    minWidth: 76,
    maxWidth: '24%',
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    paddingHorizontal: 0,
    backgroundColor: COLORS.neutral10,
    borderRightWidth: 1,
    borderRightColor: '#DEE4EA',
  },
  phonePrefixText: {
    ...TYPOGRAPHY.HEADING3,
    ...TEXT_STYLES.textNeutral90,
    ...VARIANTS_STYLES.MEDIUM,
  },
  phoneCaption: {
    ...TYPOGRAPHY.CAPTION1,
    ...TEXT_STYLES.textNeutral70,
    marginBottom: 16,
    marginLeft: 4,
  },
  phoneBigInputLabel: {
    ...TYPOGRAPHY.TEXT2,
    ...TEXT_STYLES.textPrimary100,
    ...VARIANTS_STYLES.MEDIUM,
  },
  phoneBigInputText: {
    ...TYPOGRAPHY.TEXT1,
    ...TEXT_STYLES.textNeutral90,
    ...VARIANTS_STYLES.MEDIUM,
    paddingHorizontal: 0,
  },
  cropWrap: {
    marginBottom: 18,
    columnGap: 12,
  },
  addCropTile: {
    width: 76,
    ...COMMON_STYLES.alignItemsCenter,
  },
  addCropCircle: {
    width: 76,
    height: 76,
    borderRadius: 38,
    borderWidth: 1,
    borderColor: COLORS.primary100,
    backgroundColor: COLORS.primary10,
    ...COMMON_STYLES.justifyCenter,
    ...COMMON_STYLES.alignItemsCenter,
  },
  addCropPlus: {
    ...TYPOGRAPHY.HEADING2,
    color: COLORS.primary100,
  },
  addCropText: {
    ...TYPOGRAPHY.TEXT2,
    ...TEXT_STYLES.textNeutral80,
    marginTop: 8,
    textAlign: 'center',
  },
  selectedCropCard: {
    width: 120,
    ...COMMON_STYLES.alignItemsCenter,
  },
  selectedCropImage: {
    width: 76,
    height: 76,
    borderRadius: 38,
    borderWidth: 1,
    borderColor: COLORS.neutral20,
  },
  selectedCropImageFallback: {
    width: 76,
    height: 76,
    borderRadius: 38,
    backgroundColor: COLORS.neutral20,
  },
  selectedCropName: {
    ...TYPOGRAPHY.CAPTION1,
    ...TEXT_STYLES.textNeutral90,
    marginTop: 6,
    textAlign: 'center',
  },
  selectField: {
    minHeight: 58,
    borderWidth: 1,
    borderColor: '#CED8E0',
    borderRadius: 8,
    backgroundColor: COLORS.white,
    paddingHorizontal: 16,
    marginBottom: 12,
    ...COMMON_STYLES.row,
    ...COMMON_STYLES.alignItemsCenter,
    ...COMMON_STYLES.justifyBetween,
  },
  selectFieldLabel: {
    ...TYPOGRAPHY.CAPTION1,
    ...TEXT_STYLES.textNeutral80,
    marginBottom: 2,
  },
  selectFieldText: {
    ...TYPOGRAPHY.TEXT1,
    ...TEXT_STYLES.textNeutral90,
    ...VARIANTS_STYLES.BASE,
  },
  downIconWrap: {
    width: 28,
    height: 28,
    ...COMMON_STYLES.alignItemsCenter,
    ...COMMON_STYLES.justifyCenter,
  },
  dropdownTriangle: {
    width: 0,
    height: 0,
    borderLeftWidth: 8,
    borderRightWidth: 8,
    borderTopWidth: 10,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderTopColor: '#2F353A',
  },
  sheetHint: {
    ...TYPOGRAPHY.TEXT2,
    ...TEXT_STYLES.textNeutral70,
    marginTop: 12,
  },
  sheetItem: {
    paddingVertical: 12,
    borderBottomColor: COLORS.neutral20,
    borderBottomWidth: 1,
  },
  sheetItemText: {
    ...TYPOGRAPHY.TEXT2,
    ...TEXT_STYLES.textNeutral90,
  },
  sheetItemSubtext: {
    ...TYPOGRAPHY.CAPTION1,
    ...TEXT_STYLES.textNeutral70,
    marginTop: 2,
  },
  cropGridContainer: {
    paddingTop: 12,
    paddingBottom: 8,
  },
  cropGridRow: {
    justifyContent: 'flex-start',
    columnGap: 4,
  },
  cropGridItem: {
    width: 96,
    marginRight: 0,
    marginBottom: 12,
  },
  cropGridList: {
    flex: 1,
  },
  cropSheetBody: {
    height: 420,
  },
  sheetBody: {
    height: 420,
  },
  cropGridImage: {
    width: 72,
    height: 72,
    borderRadius: 36,
  },
  cropGridImageSelected: {
    borderWidth: 2,
    borderColor: COLORS.primary100,
  },
  errorText: {
    ...TYPOGRAPHY.CAPTION1,
    color: COLORS.error100,
    marginTop: -8,
    marginBottom: 10,
    marginLeft: 4,
  },
})

export default styles
